import script from "./SmallOrderMaterialLibrary.vue?vue&type=script&lang=ts&setup=true"
export * from "./SmallOrderMaterialLibrary.vue?vue&type=script&lang=ts&setup=true"

import "./SmallOrderMaterialLibrary.vue?vue&type=style&index=0&id=a9d2abf0&lang=css"

const __exports__ = script;

export default __exports__